import objectPath from 'object-path'

const getters = {
  isLoading: state => state.isLoading,
  isLoadingMore: state => state.isLoadingMore,
  isUpdating: state => state.isUpdating,
  getField: state => target => objectPath.get(state, target),
  getFormForSearch: (state) => {
    const {
      placeFrom: {
        slug
      },
      placeToId,
      placeToType,
      checkInDate,
      duration,
      rooms,
      page,
      perPage,
      priceSort,
      currency
    } = state.form

    return {
      placeFromId: slug,
      placeToId,
      placeToType,
      checkInDate,
      duration,
      rooms,
      page,
      perPage,
      priceSort,
      currency,
      filters: state.filters
    }
  },
  getForm: state => ({
    ...state.form,
    filters: state.filters
  }),
  getTourists: state => ({
    adults: state.form.rooms.reduce((sum, room) => (sum + room.adults), 0),
    children: state.form.rooms.reduce((sum, room) => (sum + room.children), 0),
  }),
  isFiltersApplied: state => state.isFiltersApplied,
  isEmptySearchResults: state => state.isEmptySearchResults,
  isFiltersDisabled: state => state.isFiltersDisabled,
  showForm: state => state.showForm,
  showSearch: state => state.showSearch,
  getCollection: state => state.collection,
  getFilters: state => state.filters,
  getCollectionFilters: state => state.collectionFilters,
  getMinPrices: state => state.minPrices,
  showAgencyPrice: state => state.agencyPrice,
  getViewType: state => state.viewType,
  getPagination: state => state.pagination,
  departureCities: state => state.departureCities,
  markedDates: state => state.markedDates,
  isCalendarLoading: state => state.isCalendarLoading
}

export default getters